import {apiPost} from '@/api/api.ts'

type IResLogin = {
    token: string;
    // refreshToken은 HttpOnly Cookie로 서버에서 자동 설정됨 (응답 body에 포함 안 됨)
}

export interface IReqLogin {
    id: string
    password: string
}

export const apiLogin = async (params: IReqLogin) => {
    // credentials: 'include'는 이미 apiPost에서 처리됨
    return await apiPost<IResLogin>(`/auth/login`, params)
}
